<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: rgba(7, 53, 245, 1) !important;
}

//.monitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 10px 10px 0px 20px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          待维修/维修中任务
        </div>
      </div>
      <div :style="{ height: contentHeight + 'px' }" style="padding: 0px 16px;">
        <el-table ref="table" class="monitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
          <el-table-column :label="$t('mojubianhao')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.mouldNo) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('mojumingcheng')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.mouldName) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('guzhangmiaoshu')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.errorDesc) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('weixiuren')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.repairer) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('weixiuzhuangtai')">
            <template slot-scope="scope">
              <div style="font-weight: bold;font-size: 15px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;border:1px solid rgba(255, 58, 94, 1)" :style="{ color: textColor[scope.row.repairStatus], 'border-color': textColor[scope.row.repairStatus], 'background-color': bgColor[scope.row.repairStatus] }">
                {{ $t({ '0': 'daichuli', '1': 'weixiuzhong', '2': 'yiwancheng' }[scope.row.repairStatus]) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      textColor: { '0': 'rgba(255, 58, 94, 1)', '1': 'rgba(255, 200, 58, 1)', '2': 'rgba(57, 241, 109, 1)' },
      bgColor: { '0': 'rgba(255, 58, 94, 0.2)', '1': 'rgba(255, 200, 58, 0.2)', '2': 'rgba(57, 241, 109, 0.2)' },

      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list: [],

      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/mould/repair/list');
      this.list = response.data;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 10;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
